export const SanitizedUrlKeys = ["action"];